<template>
  <div id="layout-wrapper ">
    <header id="page-topbar">
      <div class="layout-width">
        <div class="navbar-header d-flex justify-content-end my-1">
          <div class="d-flex align-items-center">
            <div class="dropdown d-md-none topbar-head-dropdown header-item">
              <button
                type="button"
                class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
                id="page-header-search-dropdown"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i class="bx bx-search fs-22"></i>
              </button>
              <div
                class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                aria-labelledby="page-header-search-dropdown"
              >
                <form class="p-3">
                  <div class="form-group m-0">
                    <div class="input-group">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Search ..."
                        aria-label="Recipient's username"
                      />
                      <button class="btn btn-primary" type="submit">
                        <i class="mdi mdi-magnify"></i>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <div class="dropdown ms-sm-3 header-item topbar-user">
              <button
                type="button"
                class="btn"
                id="page-header-user-dropdown"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <span class="d-flex align-items-center">
                  <img
                    class="rounded-circle header-profile-user"
                    src="/images/users/pro.png"
                    alt="Header Avatar"
                  />

                  <span class="text-start ms-xl-2">
                    <span
                      class="d-none d-xl-inline-block ms-1 fw-bold user-name-text"
                      >{{
                        this.ldata ? this.ldata.name.toUpperCase() : "*******"
                      }}</span
                    >
                    <span
                      class="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text"
                      >{{
                        this.ldata? this.ldata.email : "**************"
                      }}</span
                    >
                  </span>
                </span>
              </button>
              <div class="dropdown-menu dropdown-menu-end">
                <h6 class="dropdown-header">Welcome {{ name }}!</h6>
                <RouterLink to="/my_profile" class="dropdown-item"
                  ><i
                    class="mdi mdi-account-circle text- fs-16 align-middle me-1"
                  ></i>
                  <span class="align-middle">Profile</span></RouterLink
                >

                <div class="dropdown-divider"></div>
                <p class="dropdown-item" @click="logout">
                  <i
                    class="mdi mdi-logout text-danger fs-16 align-middle me-1 text-danger"
                  ></i>
                  <span class="align-middle text-danger">Logout</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
import { mapState } from "pinia";
import { useAuthStore } from "@/store/auth";
import Cookies from "js-cookie";

export default {
  name: "topBar",
  methods: {
    logout() {
      localStorage.removeItem("ldata");
      Cookies.remove("accessToken");
      Cookies.remove("refreshToken");
      this.$router.push("/login");
    },
  },
  computed: {
    ...mapState(useAuthStore, ["ldata"]),
  },
};
</script>
